import { EventEmitter } from './EventEmitter'
import { addLeadingSlash, addTrailingSlash } from '../utils/slash'

export class Router extends EventEmitter {
	private readonly routes: string[] = []
	public activeRoute: string

	constructor() {
		super()
		this.routes = window.__ROUTES__
		this.activeRoute = window.location.pathname

		window.addEventListener('popstate', this.onPopState.bind(this))
	}

	push(route: string): void {
		const cleanRoute = addLeadingSlash(addTrailingSlash(route))
		const url = this.routes.includes(cleanRoute) ? cleanRoute : `/${document.documentElement.lang}/404/`
		if (url === this.activeRoute) {
			return
		}
		this.activeRoute = url
		window.history.pushState({}, this.activeRoute, `${window.location.origin}${this.activeRoute}`)
		this.emit('change', this.activeRoute)
	}

	onPopState(): void {
		const url = this.routes.includes(window.location.pathname)
			? window.location.pathname
			: `/${document.documentElement.lang}/404/`
		if (url === this.activeRoute) {
			return
		}
		this.activeRoute = url
		this.emit('change', this.activeRoute)
	}
}
